import { render, staticRenderFns } from "./DashboardVehicleLogs.vue?vue&type=template&id=4c98c80b&scoped=true"
import script from "./DashboardVehicleLogs.vue?vue&type=script&lang=js"
export * from "./DashboardVehicleLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c98c80b",
  null
  
)

export default component.exports